import { FC, useState } from 'react';

import { ArrowRightOutlined } from '@ant-design/icons';
import { Button, Divider, Form, Input, Modal } from 'antd';

import { User } from '../../@types/user';
import message from '../../common/message';
import { getPartnerCompanyId } from '../../helpers/util';
import history from '../../routes/history';

interface ICreate {
  visible: boolean;
  createHandbook: Function;
  current: User;
  onCancel: Function;
}

const Create: FC<ICreate> = ({ visible, onCancel, current, createHandbook }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onClose = () => {
    form.resetFields();
    onCancel();
  };

  const onFinish = (values: any) => {
    setLoading(true);
    createHandbook({
      payLoad: {
        name: values.name,
        statusId: 1,
        description: '',
        partnerCompanyId: getPartnerCompanyId(current),
        createdBy: (current || {}).id,
      },
    }).then(
      (response: any) => {
        setLoading(false);
        onClose();
        const { id } = response.data;
        history.push(`/handbook/${id}`);
      },
      (errors: Array<any>) => {
        message.error(errors);
        setLoading(false);
      },
    );
  };

  return (
    <Modal visible={visible} title={null} footer={null} width={1000} onCancel={() => onCancel()}>
      <div className='grid grid-cols-2 gap-4 p-4'>
        <div className={'relative'}>
          <div className='px-10'></div>
          <Divider className={'absolute right-0 top-8'} type='vertical' style={{ height: 270 }} />
        </div>
        <div className={'px-12'}>
          <div className='flex items-center'>
            <Form
              name='handbookForm'
              className={'w-full'}
              layout='vertical'
              form={form}
              onFinish={onFinish}
            >
              <Form.Item
                label='Handbook title'
                name='name'
                rules={[{ required: true, message: 'Handbook title is required' }]}
              >
                <Input
                  className='form__input form__input--block'
                  placeholder='eg. Handbook title'
                />
              </Form.Item>

              <Form.Item>
                <div className='flex justify-between gap-4'>
                  <Button
                    className='btn btn--default'
                    block
                    size={'large'}
                    onClick={() => onClose()}
                  >
                    Cancel
                  </Button>
                  <Button
                    className='btn btn--primary'
                    type='primary'
                    htmlType='submit'
                    block
                    size={'large'}
                    loading={loading}
                  >
                    Next
                    <ArrowRightOutlined className={'float-right mt-1'} />
                  </Button>
                </div>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default Create;
